import React, { useState } from 'react';
import { colours } from 'styling/colours';
import config from 'react-global-configuration';
import useBroadcastChannel from 'hooks/useBroadcastChannel';
import { useRootStore } from 'contexts/RootStore.context';
import { Dropdown } from 'components/inputs/Dropdown/Dropdown';
import { PageMask } from 'components/Loading/PageMask';
import { TextLink } from 'components/TextLink';
import { style } from 'typestyle';
import TextButton from 'components/Button/TextButton';

type UserInfoDropdownProps = {
  onItemClick?: () => void;
}
const UserInfoDropdown = ({ onItemClick }: UserInfoDropdownProps) => {
  const { userInfo } = useRootStore();
  const { name, username } = userInfo;
  const [logoutProgress, setLogoutProgress] = useState(false);
  const { postBroadcastMessage } = useBroadcastChannel();

  const logoutHandler = () => {
    setLogoutProgress(true);
    postBroadcastMessage('broadcast_signout');
  }

  return (
    <>
      <PageMask isShow={logoutProgress} />
      <Dropdown
        ariaLabel='Profile'
        id='profile'
        title={name ? name : username}
        menuItems={
          <>
            <TextLink className={linkStyle} to="/support" onClick={onItemClick}>
              Support
            </TextLink>
            <a
              className={linkStyle}
              href={config.get('HELP_URL')}
              target="_blank"
              onClick={onItemClick} rel="noreferrer"
            >
              Help
            </a>
            <TextButton
              title="Logout"
              disabled={logoutProgress}
              className={logoutStyle}
              onClick={logoutHandler}
            >
              Sign out
            </TextButton>
          </>
        }
      />
    </>
  );
};


export default UserInfoDropdown;

const baseLinkStyle = {
  width: "100%",
  padding: "0 12px",
  color: `${colours.primaryText} !important`,
  lineHeight: "36px",
  $nest: {
    "&:focus": {
      outline: `1px solid ${colours.secondary}`,
      outlineOffset: "-1px"
    },
    "&:hover": {
      background: colours.background,
      color: `${colours.secondary} !important`,
    },
  },
};

const linkStyle = style({
  ...baseLinkStyle,
  textDecoration: "none",
});

const logoutStyle = style({
  width: "100%",
  textAlign: "left",
  color: `${colours.error} !important`,
  $nest: {
    "&:hover": {
      background: colours.background,
      color: `${colours.error} !important`,
    },
  },
});
